import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import DocumentScanner from '../../components/DocumentScanner';

export default function ScanFrontPage({
    frontImage,        // bereits erfasstes Bild (oder null)
    setFrontImage,     // Funktion zum Speichern des Bildes
    onNext,            // Callback, um zum nächsten Step zu gehen
}) {
    // Lokales State, ob wir das Scanner-UI anzeigen oder das fertige Bild
    // Du kannst das aber auch am "frontImage" festmachen (wenn frontImage != null => wir haben was)
    const [hasScanned, setHasScanned] = useState(!!frontImage);

    const handleCaptureComplete = (dataUrl) => {
        console.log("Front-Seite erfasst:", dataUrl.length, "Zeichen");
        setFrontImage(dataUrl);
        setHasScanned(true);
    };

    const handleRescan = () => {
        // Falls man nochmal scannen will:
        setFrontImage(null);
        setHasScanned(false);
    };

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom>
                Schritt 1: Vorderseite scannen
            </Typography>

            {!hasScanned ? (
                <DocumentScanner onCaptureComplete={handleCaptureComplete} />
            ) : (
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="body1" gutterBottom>
                        Folgendes Bild wurde erfasst (Vorderseite):
                    </Typography>
                    <img
                        src={frontImage}
                        alt="Vorderseite"
                        style={{ maxWidth: '100%', border: '1px solid #ccc', borderRadius: 8 }}
                    />

                    <Box mt={2}>
                        <Button variant="outlined" onClick={handleRescan} sx={{ mr: 2 }}>
                            Erneut scannen
                        </Button>
                    </Box>
                </Box>
            )}

            <Box mt={2} sx={{ textAlign: 'right' }}>
                {/* Weiter-Button ist nur aktiviert, wenn wir ein frontImage haben */}
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!frontImage}
                    onClick={onNext}
                >
                    Weiter
                </Button>
            </Box>
        </Box>
    );
}
